import { createSelector } from '@reduxjs/toolkit'
import { ApplicationState } from 'redux/Stores/types'
import {
  GlobalFilterVariant,
  TGlobalFilterApiInput,
  TGlobalFilterSelected
} from 'types/GlobalGlobalFilter'

export const selectGlobalFilter = createSelector(
  [
    (state: ApplicationState) => state.GlobalFilterStore,
    (state: ApplicationState) => state.CompanyGroupStore.data
  ],
  (globalFilterStore, companyGroupStore): TGlobalFilterSelected => ({
    variant: globalFilterStore.variant,
    customSelected: globalFilterStore.customSelected,
    companyGroup: globalFilterStore.companyGroupId
      ? companyGroupStore[globalFilterStore.companyGroupId] || null
      : null,
    isInitialized: globalFilterStore.isInitialized
  })
)

export const selectGlobalFilterForApi = createSelector(
  [
    selectGlobalFilter,
    (state: ApplicationState) => state.CurrencyConverterStore.currency
  ],
  (filter, currency): TGlobalFilterApiInput => ({
    company_group_id: filter.companyGroup?.id || null,
    convert_to_currency: currency,
    custom_selected: filter.customSelected,
    variant: filter.variant
  })
)

/**
 * Get save key for global filter (used for caching widget data).
 * Returns 'all', 'standard', comma-separated list of real estate IDs,
 * or companyGroupId for company group variant.
 *
 * @param state - Application state
 * @returns Save key string for caching
 */
export const selectGlobalFilterSaveKey = createSelector(
  [selectGlobalFilter, (state: ApplicationState) => state.MyScopeStore.data],
  (filter, myScopes): string | null => {
    if (filter.variant === GlobalFilterVariant.COMPANY_GROUP) {
      return filter.companyGroup?.id || null
    }

    if (filter.variant === GlobalFilterVariant.ALL) {
      return GlobalFilterVariant.ALL
    }

    const units =
      filter.variant === GlobalFilterVariant.STANDARD
        ? myScopes
        : filter.customSelected

    return [...units].sort().join(',')
  }
)
